import { CSVField } from "./csv-field";
import { useCampaignList } from "../hooks/use-campaign-list";

export const MarketingCampaignCSVInput = () => {
	const { onAddVoucherGiftListItemsFromCSV } = useCampaignList();

	return <CSVField onSetCampaignList={onAddVoucherGiftListItemsFromCSV} errorMessage={undefined} />;
};

MarketingCampaignCSVInput.displayName = "MarketingCampaignCSVInput";
